/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';

/**
 * Internal dependencies
 */
import {openNotification} from '../../functions';
import { loaderIcon } from '../../assets/icons';

export default function License() {
    let  msg='';
    let _localizeData = rv_dashboard_data.dashboardData || {}; // localize data
    const licenseData = _localizeData?.license_data || {};

    const [inputValue, setInputValue] = useState('');
    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState( licenseData?.status || 'deactive');
    const [expirationMessage, setExpirationMessage] = useState('');

    // Check expiration and set message
    const checkExpiration = () => {
        const expiresAt = licenseData?.expires_at;
        const currentStatus = licenseData?.status || 'inactive';
        
        if (currentStatus === 'expired') {
            setExpirationMessage(licenseData?.message || 'Your license has expired. Please renew to continue using premium features.');
            setStatus('expired');
            return;
        }

        if (expiresAt && expiresAt !== 'lifetime') {
            const expirationDate = new Date(expiresAt);
            const now = new Date();
            const daysRemaining = Math.floor((expirationDate - now) / (1000 * 60 * 60 * 24));

            if (daysRemaining < 0) {
                setExpirationMessage('Your license has expired. Please renew to continue using premium features.');
                setStatus('expired');
            } else if (daysRemaining <= 7) {
                setExpirationMessage(`⚠️ Your license expires in ${daysRemaining} day(s). Please renew soon to avoid interruption.`);
            } else if (daysRemaining <= 30) {
                const formattedDate = expirationDate.toLocaleDateString();
                setExpirationMessage(`ℹ️ Your license expires on ${formattedDate} (${daysRemaining} days remaining).`);
            }
        }
    };

    // Check expiration on component mount
    useEffect(() => {
        checkExpiration();
    }, []);

    const handleButtonClick = async (event, action) => {
        event.preventDefault();
        setLoader(true);

        // Pass data to the API using wp.apiFetch
        wp.apiFetch({
            path: '/riovizualpro/v2/license_trigger',
            method: 'POST',
            data: {
                action,
                inputValue,
            },
        })
        .then((response) => {
            setLoader(false);
            setStatus(response.status || response.currentStatus || 'deactive');
            let msg = response.message;
            
            // Check if license expired
            if (response.status === 'expired' || response.currentStatus === 'expired' || !response.isValid) {
                setExpirationMessage(msg || 'Your license has expired or is invalid.');
                setStatus('expired');
            } else {
                setExpirationMessage('');
            }
            
            let notice_status = (response.status === 'active' || response.status === 'deactive') ? 'success' : 'error';
            // show notice
            openNotification( notice_status, msg, '');
            // console.log('response', response);

            // Reload page to get updated license data
            setTimeout(() => {
                window.location.reload();
            }, 300);
        })
        .catch((error) => {
            // console.log('error', error);
            setLoader(false);
        });
    };

    return (
        <div className="rv_dash-settings-page">
            <div className="rv_dash-lisence-box">
                    <div className="rv_dash-lisence-status">
                        <h5>{__('Plugin License')}</h5>
                        <div className="rv_dash-lisence-status-btn">
                            {__('Status: ')}
                            <span className={classnames(
                                status === 'active' ? 'rv_dash-lisence-active' : 
                                status === 'expired' ? 'rv_dash-lisence-expired' : 
                                'rv_dash-lisence-inactive'
                            )}>
                                {status === 'active' ? __('Active') : 
                                    status === 'expired' ? __('Expired') : 
                                    __('License is not active')}
                            </span>
                        </div>
                        
                    </div>
                <form id="apiKeyCheckForm" method="POST" >
                    <div className="">
                        <div className="form-row">
                            <label for="api_key" className="form-label">{__('License API Key:')}</label>
                            <input
                                type="text"
                                name="rv_license_key"
                                placeholder={ __( 
                                    status === 'active' ? '🔑  Your license is active.' : 
                                    status === 'expired' ? '⚠️  Your license has expired. Enter a new license key.' :
                                    'Paste your license key here.' 
                                ) }
                                value={status === 'active' ? '' : inputValue}
                                disabled={status === 'active'}
                                onChange={(e) => setInputValue(e.target.value)} 
                            />
                        </div>
                        {licenseData?.expires_at && licenseData.expires_at !== 'lifetime' && (
                            <div className="rv_dash-lisence-expiry">
                                <small>
                                    {status === 'expired' ? __('Expired on: ') : __('Expires on: ')}
                                    {new Date(licenseData.expires_at).toLocaleDateString()}
                                </small>
                            </div>
                        )}
                        {expirationMessage && (
                            <div className={classnames(
                                'rv_dash-lisence-message',
                                status === 'expired' ? 'rv_dash-lisence-message-error' : 'rv_dash-lisence-message-warning'
                            )}>
                                <small>{expirationMessage}</small>
                            </div>
                        )}
                        {msg && <small>{__(msg)}</small>}
                    </div>
                    <button
                        className={classnames(
                            'rv_dash-lisence-submit-btn',
                            {'rv_key_btn_loader': loader}
                        )}
                        disabled={status !== 'active' && !inputValue.trim()}
                        onClick={(event) => handleButtonClick(event, status === 'active' ? 'deactive' : 'active')}
                    >
                    { __(status === 'active' ? 'Deactivate License' : 'Activate') }
                    { loader && loaderIcon }
                    </button>
                </form>
            </div>
        </div>
    )
}


